import script from "./BaseFilterSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFilterSwitch.vue?vue&type=script&setup=true&lang=js"

import "./BaseFilterSwitch.vue?vue&type=style&index=0&id=d4c3e12e&lang=scss"

const __exports__ = script;

export default __exports__